import { forwardRef } from "react";

function Root(props, ref) {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.58" d="M24 0H0V24H24V0Z" />
      <path
        d="M12.0002 22.61C11.7102 22.61 11.4203 22.54 11.1503 22.39L9.67023 21.68C9.30023 21.5 9.14025 21.05 9.32025 20.68C9.50025 20.31 9.94025 20.15 10.3203 20.33L11.8303 21.06C11.9403 21.12 12.0402 21.12 12.1102 21.08L20.1102 16.64C20.1902 16.6 20.2402 16.51 20.2402 16.42V7.60002C20.2402 7.51002 20.1902 7.43001 20.1102 7.38001L12.1102 2.94002C12.0302 2.90002 11.9402 2.90002 11.8702 2.94002L3.87024 7.38001C3.79024 7.42001 3.74023 7.51002 3.74023 7.60002V16.42C3.74023 16.51 3.79024 16.59 3.87024 16.64L6.38025 18.03C6.77025 18.25 7.23024 18.24 7.62024 18.01C8.01024 17.78 8.24023 17.38 8.24023 16.93L8.25024 9.00002C8.25024 8.59002 8.59024 8.25002 9.00024 8.25002C9.41024 8.25002 9.75024 8.59002 9.75024 9.00002L9.74023 16.93C9.74023 17.91 9.23025 18.8 8.38025 19.3C7.53025 19.8 6.51027 19.81 5.65027 19.33L3.14026 17.94C2.58026 17.63 2.24023 17.04 2.24023 16.41V7.59001C2.24023 6.96001 2.58026 6.37001 3.14026 6.06001L11.1403 1.62002C11.6703 1.32002 12.3103 1.32002 12.8403 1.62002L20.8403 6.06001C21.4003 6.37001 21.7402 6.96001 21.7402 7.59001V16.41C21.7402 17.04 21.4003 17.63 20.8403 17.94L12.8403 22.38C12.5803 22.53 12.2902 22.61 12.0002 22.61Z"
        fill="#fff"
      />
      <path
        opacity="0.4"
        d="M15.25 16.75H13.5C12.12 16.75 11 15.63 11 14.25C11 13.84 11.34 13.5 11.75 13.5C12.16 13.5 12.5 13.84 12.5 14.25C12.5 14.8 12.95 15.25 13.5 15.25H15.25C15.8 15.25 16.25 14.8 16.25 14.25C16.25 13.7 15.8 13.25 15.25 13.25H13.5C12.12 13.25 11 12.13 11 10.75C11 9.37 12.12 8.25 13.5 8.25H15.25C16.63 8.25 17.75 9.37 17.75 10.75C17.75 11.16 17.41 11.5 17 11.5C16.59 11.5 16.25 11.16 16.25 10.75C16.25 10.2 15.8 9.75 15.25 9.75H13.5C12.95 9.75 12.5 10.2 12.5 10.75C12.5 11.3 12.95 11.75 13.5 11.75H15.25C16.63 11.75 17.75 12.87 17.75 14.25C17.75 15.63 16.63 16.75 15.25 16.75Z"
        fill="#fff"
      />
    </svg>
  );
}
const JavaScript = forwardRef(Root);
export default JavaScript;
